$color-font: #495057;
$color-white: #ffffff;
$color-active-step: #d3dae2;

.onboarding__step {
  display: flex;
  align-items: center;
  padding: 0.9rem 1rem;
  width: 100%;
  @media (max-width: 991px) {
    justify-content: center;
  }
}

.onboarding__stepIcon {
  background-color: $color-font;
  border-radius: 50%;
  padding: 0.5rem;
  color: $color-white;
  font-weight: 600;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.05rem;
}

.onboarding__stepName {
  color: $color-font;
  font-size: 1rem;
  margin-left: 15px;
}

.active {
  &.onboarding__step {
    background-color: $color-active-step;
  }
}

.completed {
  &.onboarding__step {
    background-color: $color-font;
  }
  .onboarding__stepIcon {
    background-color: $color-white;
    color: $color-font;
  }

  .onboarding__stepName {
    color: $color-white;
  }
}
